import { render } from "./DocumentsGalleryModal.vue?vue&type=template&id=368cf2a0&scoped=true&ts=true"
import script from "./DocumentsGalleryModal.vue?vue&type=script&lang=ts"
export * from "./DocumentsGalleryModal.vue?vue&type=script&lang=ts"

import "./DocumentsGalleryModal.vue?vue&type=style&index=0&id=368cf2a0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-368cf2a0"]])

export default __exports__